import {
  faBriefcase,
  faEnvelopeOpen,
  faHome,
  faUser,
} from '@fortawesome/free-solid-svg-icons';

const menuItems = [
  {
    icon: faHome,
    shortName: 'menu.home.shortname',
    longName: 'menu.home.longname',
    path: '/',
  },
  {
    icon: faUser,
    shortName: 'menu.resume.shortname',
    longName: 'menu.resume.longname',
    path: '/about',
  },
  {
    icon: faBriefcase,
    shortName: 'menu.realisations.shortname',
    longName: 'menu.realisations.longname',
    path: '/realisations',
  },
  {
    icon: faEnvelopeOpen,
    shortName: 'menu.contact.shortname',
    longName: 'menu.contact.longname',
    path: '/parler',
  },
];

export default menuItems;
